// src/router/auth.js
const authRoutes = [
  {
    path: "/",
    name: "Root",
    redirect: "/login",
  },
  // Mail app has no public product catalog.
  // Keep legacy routes as redirects to login.
  {
    path: "/products",
    redirect: "/login",
  },
  {
    path: "/products/:slug",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/auth/Login.vue"),
  },
  {
    path: "/register",
    redirect: "/login",
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/auth/ForgotPassword.vue"),
  },
  {
    path: "/forgot-passward",
    redirect: "/forgot-password",
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/auth/ResetPassword.vue"),
  },
  {
    path: "/confirm-mail",
    name: "ConfirmMail",
    component: () => import("../views/auth/ConfirmMail.vue"),
  },
  {
    path: "/lock-screen",
    name: "LockScreen",
    component: () => import("../views/auth/LockScreen.vue"),
  },
  {
    path: "/otp",
    name: "OTP",
    component: () => import("../views/auth/OTP.vue"),
  },
  {
    path: "/login-otp",
    name: "LoginOTP",
    component: () => import("../views/auth/LoginOTP.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () => import("../views/auth/ChangePassword.vue"),
  },
  {
    path: "/social-callback",
    name: "SocialCallback",
    component: () => import("../views/auth/SocialCallback.vue"),
  },
  {
    path: "/403",
    name: "MailError403",
    component: () => import("../views/errors/MailErrorView.vue"),
    props: { status: 403 },
  },
  {
    path: "/404",
    name: "MailError404",
    component: () => import("../views/errors/MailErrorView.vue"),
    props: { status: 404 },
  },
  {
    path: "/419",
    name: "MailError419",
    component: () => import("../views/errors/MailErrorView.vue"),
    props: { status: 419 },
  },
  {
    path: "/500",
    name: "MailError500",
    component: () => import("../views/errors/MailErrorView.vue"),
    props: { status: 500 },
  },
  {
    path: "/503",
    name: "MailError503",
    component: () => import("../views/errors/MailErrorView.vue"),
    props: { status: 503 },
  },
  {
    path: "/super-admin/login",
    name: "SuperAdminLogin",
    component: () => import("../views/SuperAdmin/SuperAdminLoginView.vue"),
  },
];

export default authRoutes;
